module.exports = __webpack_public_path__ + "img/hcms.43c92946.svg";